import {
  SET_AGENCY
} from '../actions/types';

const INITIAL_STATE = {
  isSet: false
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_AGENCY:
      return { ...state, isSet: true, ...action.payload };
    default:
      return state;
  }
};
